// Round value to match step. Don't account for float point imprecision.
export const roundValue =
    (step: number) =>
    (value: number): number =>
        Math.round(value / step) * step;
